export default "! Hamilton12-24_25no23.scl\n!\nHamilton12-24_25no23\n12\n!\n12/11\n8/7\n6/5\n24/19\n4/3\n24/17\n3/2\n8/5\n12/7\n24/13\n48/25\n2/1\n"